export default __webpack_public_path__ + "static/media/guideags.0fbb1c28.jpg";